/*
* Copyright (C) Regione Lombardia
*/
import { Component, EventEmitter, Input, OnDestroy, Output } from "@angular/core";

@Component({
    selector: 'app-toolkit-upload-file',
    templateUrl: './upload-file.component.html',
    styleUrls: ['./upload-file.component.scss']
})
export class SharedToolkitUploadFileComponent implements OnDestroy {

    @Input() id: string;
    @Input() disabled: boolean = false;
    @Input() fileName: string | undefined;

    @Output() completed: EventEmitter<any> = new EventEmitter<any>();

    public fileToUpload: File | null;

    ngOnDestroy() {
        this.reset();
    }

    public handleFileInput(target: any) {
        if (target.value) {
            this.fileToUpload = target.files.item(0) || null;
            this.fileName = this.fileToUpload?.name;
            this.completed.emit(this.fileToUpload);
        }
        target.value = null;
    }

    public reset() {
        this.fileName = undefined;
        this.fileToUpload = null;
    }

}
